// Viewport
export const SET_VIEWPORT = 'SET_VIEWPORT';

// Scroll
export const SET_SCROLL = 'SET_SCROLL';
export const LOCK_SCROLL = 'LOCK_SCROLL';

// Router
export const SET_ROUTE_DATA = 'SET_ROUTE_DATA';
export const SET_PARTIALS_DATA = 'SET_PARTIALS_DATA';

// Project
export const SET_PAGE_TYPE = 'SET_PAGE_TYPE';
export const DISMISS_HOME_INTRO = 'DISMISS_HOME_INTRO';
export const ADD_MEDIA_ITEM = 'ADD_MEDIA_ITEM';
export const REMOVE_MEDIA_ITEM = 'REMOVE_MEDIA_ITEM';
export const SET_LOCATION_NAV = 'SET_LOCATION_NAV';
export const TOGGLE_MAP_NAV = 'TOGGLE_MAP_NAV';

// Navigation
export const SET_MOBILE_NAVIGATION = 'SET_MOBILE_NAVIGATION';

// Overlay
export const OPEN_OVERLAY = 'OPEN_OVERLAY';
export const CLOSE_OVERLAY = 'CLOSE_OVERLAY';



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/vuex/mutation-types.js